import UserList from '@User/views/UserList.vue';
import InviteUserList from '@User/views/InviteUserList.vue';
import UserProfile from '@User/views/UserProfile.vue';
import permissions from '@Share/config/permissions';

export default [
  {
    path: '/users',
    name: 'users',
    component: UserList,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Users',
      permissions: [permissions.Users.View],
    },
  },
  {
    path: '/users/:id',
    name: 'userProfile',
    component: UserProfile,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'User Profile',
    },
  },
  {
    path: '/users-invitation',
    name: 'users-invitation',
    component: InviteUserList,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Users Invitation',
      permissions: [permissions.Users.Create],
    },
  },
];
